import { render, staticRenderFns } from "./my-account-detail.vue?vue&type=template&id=273831fa&scoped=true"
import script from "./my-account-detail.vue?vue&type=script&lang=js"
export * from "./my-account-detail.vue?vue&type=script&lang=js"
import style0 from "./my-account-detail.vue?vue&type=style&index=0&id=273831fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273831fa",
  null
  
)

export default component.exports